var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-bar',{attrs:{"voltar":"admin/colaboradores"}}),_vm._v(" "),_c('menu-dash'),_vm._v(" "),_c('div',{staticClass:"w3-main",staticStyle:{"margin-left":"300px","margin-top":"50px"}},[_c('formulario',{attrs:{"editar":false}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-976c042c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/colaborador/AdminColaboradorCadastrar.vue
// module id = null
// module chunks = 